<template>
    <div class="container">
        <div class="result">
            <div class="detail">
                <img
                    class="img_ant"
                    src="../assets/images/insects/img_ant.png"
                >
                <img
                    class="words"
                    src="../assets/images/insects/words.png"
                >
            </div>
            <div class="code"><img src="../assets/images/insects/password.png"></div>
            <div class="medal"><img src="../assets/images/insects/words02.png"></div>
            <div class="btns">
                <img
                    @click="replay"
                    src="../assets/images/insects/btn_replay.png"
                >
                <img
                    @click="convert2img"
                    src="../assets/images/insects/btn_share.png"
                >
            </div>
        </div>

        <!-- 分享 -->
        <div
            class="share"
            id="share"
        >
            <div class="stone_logo"><img src="../assets/images/insects/stone_logo.png"></div>
            <div class="done">
                <h2>恭喜你成为 <span>HZ{{code}}</span> 号探员！</h2>
                <h2>你出色地完成了这次混知调查局的<br>昆虫大发现任务！ <br>特此颁发荣誉徽章。</h2>
            </div>
            <div class="listen"><img src="../assets/images/insects/qrcode.png"></div>
            <p>扫码免费收听21集昆虫大发现音频课程</p>
        </div>
        <div
            v-show="shareImgFlag"
            class="shareImgBox"
        >
            <div class="shareContend">
                <div
                    class='mackClose'
                    @click="close"
                ><img src="../assets/images/insects/btn_close.png"></div>
                <p>长按图片保存至相册，快去分享吧！</p><img
                    :src="shareImg"
                    crossOrigin="anonymous"
                />
            </div>
        </div>
    </div>

</template>
<script>
import wxapi from "../utils/wxapi.js";
import html2canvas from "../utils/html2canvas";
import axios from "axios";
import { Toast } from "vant";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      code: "",
      shareImg: "",
      shareImgFlag: false,
    };
  },
  created() {
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
    });
    const that = this;
    that.timer = setInterval(function() {
      console.log(document.readyState);
      if (document.readyState === "complete") {
        console.log("完成");
        console.log(that.timer);
        setTimeout(function() {
          Toast.clear();
        }, 3000);
        window.clearInterval(that.timer);
      }
    }, 1000);
    this.getId();
  },
  mounted() {
    wxapi.wxRegister(this.wxRegCallback);
  },
  methods: {
    close() {
      this.shareImgFlag = false;
    },
    convert2img() {
      // if(localStorage.getItem('imgUrl')){
      //     this.shareImgFlag=true;
      //    this.shareImg=localStorage.getItem('imgUrl');
      // }else{
      // Toast.loading({
      //     message: '加载中...',
      //     forbidClick: true,
      //     duration: 0,
      // });
      let that = this;
      let $share = document.querySelector("#share");
      (window.html2canvas || html2canvas)($share, {
        allowTaint: true,
        taintTest: false,
        scale: 2,
        useCORS: true,
        width: $share.offsetWidth,
        height: $share.offsetHeight,
      }).then(function(canvas) {
        // img为base64格式的图片
        let img = canvas.toDataURL("image/jpeg", 1.0);
        that.shareImgFlag = true;
        that.shareImg = img;
        // console.log(img)
        // let img =canvas.toDataURL("image/png");
        // that.upladImg(img)
      });
      // }
    },
    upladImg(base64img) {
      let data = {
        image: base64img,
      };
      let dataStr = JSON.stringify(data);
      axios({
        url: "/app/api/cms/image64",
        method: "post",
        data: JSON.parse(dataStr),
        headers: {
          "Content-Type": "application/json",
        },
      }).then((respanse) => {
        console.log("图片地址");
        console.log(respanse.data);
        if (respanse.data.msg == "成功") {
          Toast.clear();
          this.shareImgFlag = true;
          let imgUrl = respanse.data.data.baseUrl + respanse.data.data.fileName;
          this.shareImg = imgUrl;
          localStorage.setItem("imgUrl", imgUrl);
        } else {
          Toast.clear();
        }
      });
    },
    getId() {
      let id = JSON.parse(localStorage.getItem("userInfo")).id + "";
      if (id.length == 1) {
        this.code = "0000" + id;
      } else if (id.length == 2) {
        this.code = "000" + id;
      } else if (id.length == 3) {
        this.code = "00" + id;
      } else if (id.length == 4) {
        this.code = "0" + id;
      } else {
        this.code = id;
      }
    },
    replay() {
      this.$router.replace("/cms/Activity");
    },
    //分享功能
    wxRegCallback() {
      // 用于微信JS-SDK回调
      this.wxShareTimeline();
      this.wxShareAppMessage();
    },
    wxShareTimeline() {
      // 微信自定义分享到朋友圈
      let option = {
        title: "昆虫博物馆大调查！跟混局长一起回到案发现场寻找线索吧！", // 分享标题, 请自行替换
        link: 'http://m.hunzhi.com/cms/Activity?id=1', //window.location.href.split('?')[0]+'#/callup'+'?'+window.location.href.split('?')[1].split('#')[0]// 分享链接，根据自身项目决定是否需要split
        imgUrl:
          "http://hunzhi-app-static.oss-cn-shanghai.aliyuncs.com/kunchongdiaocha.jpeg", // 分享图标, 请自行替换，需要绝对路径
        success: () => {},
        error: () => {},
      };
      // 将配置注入通用方法
      wxapi.ShareTimeline(option);
    },
    wxShareAppMessage() {
      // 微信自定义分享给朋友
      let option = {
        title: "昆虫博物馆大调查！", // 分享标题, 请自行替换
        desc: "跟混局长一起回到案发现场寻找线索吧！", // 分享描述, 请自行替换
        link:'http://m.hunzhi.com/cms/Activity?id=1', //window.location.href.split('?')[0]+'#/callup'+'?'+window.location.href.split('?')[1].split('#')[0] // 分享链接，根据自身项目决定是否需要split
        imgUrl:
          "http://hunzhi-app-static.oss-cn-shanghai.aliyuncs.com/kunchongdiaocha.jpeg", // 分享图标, 请自行替换，需要绝对路径
        success: () => {},
        error: () => {},
      };
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option);
    },
  },
};
</script>
<style scoped>
.shareImgBox {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 3;
  text-align: center;
}
.shareImgBox img {
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}
.shareContend {
  width: 60%;
  margin: 0 auto;
  margin-top: 100px;
  background: #fff9df;
  padding: 10px;
  border-radius: 10px;
  position: relative;
}
.shareContend .mackClose {
  width: 64px;
  height: 64px;
  position: absolute;
  right: -30px;
  top: -30px;
}
.shareContend .mackClose img {
  width: 100%;
  height: 100%;
}
.shareContend p {
  color: #444444;

  font-size: 26px;
}
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.result {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: #fde3b7;
}
.result .detail {
  position: relative;
  height: 520px;
}
.result .detail .img_ant {
  width: 400px;
  height: 400px;
  position: absolute;
  left: 20px;
  top: 100px;
}
.result .detail .words {
  width: 360px;
  height: 377px;
  position: absolute;
  right: 20px;
  top: 40px;
  z-index: 1;
}
.result .code {
  text-align: center;
}
.result .code img {
  width: 526px;
  height: 262px;
}
.medal {
  width: 619px;
  height: 212px;
  margin: 40px auto 0 auto;
}
.medal img {
  width: 100%;
  height: 100%;
}
.btns {
  margin-top: -15px;
  display: flex;
  justify-content: center;
}
.btns img {
  width: 376px;
  height: 131px;
}

.share {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: url("../assets/images/insects/bg03.jpg");
  background-size: 100% 100%;
  text-align: center;
}
.share .stone_logo {
  text-align: center;
}
.share .stone_logo img {
  margin-top: 65px;
  width: 500px;
  height: 501px;
}
.done {
  margin-top: 20px;
}
.done h2 {
  color: #ecbc68;
  font-size: 34px;
  line-height: 60px;
}
.done h2 span {
  color: #ffffff;
}
.listen img {
  width: 223px;
  height: 271px;
}
.share p {
  margin-top: 20px;
  font-size: 26px;
  color: #fbe3b8;
}
</style>
